import { constants as coreConstants } from "../../core";

const loginAsUser = ({ accessToken, refreshToken, expiresIn }) => {
    // eslint-disable-next-line no-undef
    window.open(
        `${coreConstants.LOGIN_AS_USER_URL}/${accessToken}/${expiresIn}/${refreshToken}`,
        '_blank'
    );
};

export default loginAsUser;